import EventQueue from "../tracker/EventQueue";
import { track } from "../tracker/EventTracker";
import { send as sendMetric } from "../tracker/Metric";
import { pageTypeName } from "@escapio/portal/state/pageType";

class ClickTracker extends HTMLElement {
	constructor() {
		super();
		this.clickListener = () => {
			const trackFn = this.useEventQueue
				? EventQueue.addEventTrackerData
				: track;
			trackFn(this.category, this.action, this.label);

			if (this.metricName) {
				const fnMetric = this.useEventQueue
					? EventQueue.addMetricTrackerData
					: sendMetric;
				fnMetric(this.metricName, this.metricValue);
			}
		};
	}
	connectedCallback() {
		this.addEventListener("click", this.clickListener);
	}

	disconnectedCallback() {
		this.removeEventListener("click", this.clickListener);
	}

	get category() {
		// If the element has defined the auto-category property, we set the
		// category according to the page type.
		if (this.hasAttribute("auto-category")) {
			return pageTypeName;
		}

		return this.getAttribute("category") || undefined;
	}

	get action() {
		return this.getAttribute("action") || undefined;
	}

	get label() {
		return this.getAttribute("label") || undefined;
	}

	get useEventQueue() {
		return this.hasAttribute("use-event-queue");
	}

	get metricName() {
		return this.getAttribute("metric-name");
	}

	get metricValue() {
		return this.getAttribute("metric-value");
	}
}
customElements.define("esc-click-tracker", ClickTracker);
